<template>
  <div class="retry-or-edit-payment">
    <div class="payment-details">
      <stripe-payment
        class="payment"
        ref="stripe"
        @got-source="handleGotSource"
        @payment-error="handlePaymentError"
        :options="stripeOptions"
        :existingSubscriptionId="subscription.id"
        v-if="stripeOptions"
      />
    </div>
    <div class="feedback" v-if="success">
      Success! Your subscription to the {{ currentEdition.name }} is active.
    </div>
    <div class="feedback" v-if="error">
      {{ error }}
    </div>
    <div class="buttons">
      <action-button
        @click="done"
        v-if="success"
        class="primary-bg secondary-bg-hover"
      >
        Done
      </action-button>
      <action-button
        v-else
        @click.prevent="addPayment"
        class="retry primary-bg secondary-bg-hover"
        :busy="retrying"
      >
        Reactivate Subscription
      </action-button>
    </div>
  </div>
</template>

<style lang="less" scoped>
.retry-or-edit-payment {
  .feedback {
    margin-top: 1em;
    background: #cccccc75;
    padding: 0.75em;
    border-radius: 5px;
  }
  .buttons {
    margin-bottom: 1em;
    .retry {
      height: 3em;
    }
  }
  .payment-method {
    line-height: 2em;
    .edit {
      text-decoration: none;
      padding: 5px 18px;
      display: inline;
      width: fit-content;
      color: #333;
      background: #ccc;
      border-radius: 999px;
      margin-left: 8px;
      position: relative;
      position: relative;
    }
  }
  .due {
    margin-top: 1em;
    font-weight: bold;
  }
}
</style>

<script>
import axios from "axios";
import swal from "sweetalert";
import { mapGetters } from "vuex";
import ActionButton from "@/common/components/ActionButton";
import StripePayment from "@/signup/StripePayment";

export default {
  components: { StripePayment, ActionButton },
  props: {
    subscription: {
      type: Object,
      required: true,
    },
    displayAmountDue: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      stripeOptions: null,
      editing: false,
      retrying: false,
      success: false,
      error: false,
    };
  },
  computed: {
    ...mapGetters(["currentEdition", "totalPrice", "seats", "pricingPeriod", "plan"]),
  },
  mounted() {
    this.getStripeOptions();
  },
  methods: {
    addPayment() {
      this.error = false;
      this.success = false;
      this.retrying = true;
      this.$refs.stripe.pay();
    },
    async getStripeOptions() {
      try {
        let response = await axios.post(
          `/api/billing/subscriptions/${this.subscription.id}/prepare_add_payment`
        );
        this.stripeOptions = response.data;
        this.editing = true;
      } catch (err) {
        this.handlePaymentError(err);
      }
    },
    async handleGotSource(source, post3ds) {
      try {
        let url = `/api/billing/subscriptions/${this.subscription.id}/add_payment`;
        await axios.post(url, {
          amount: this.totalPrice * 100,
          source: source.id,
          plan_id: this.plan.id,
          pricing_period: this.pricingPeriod,
          seats: this.seats,
        });
        this.success = true;
      } catch (err) {
        if (post3ds) {
          // was triggered from 3ds redirect, so dialog is not visible
          let message = this.getErrorMessage(err);
          swal("Error", message, "error");
        } else {
          this.handlePaymentError(err);
        }
      }

      if (this.success && this.$store) {
        // if this was triggered from the billing page after 3ds redirect,
        // store may not be present, but billing page has its own trigger
        this.$store.commit("setSubscriptionRestarted", new Date());
      }
      this.retrying = false;
    },
    getErrorMessage(messageOrError) {
      let message = "Try editing your payment method.";
      if (typeof messageOrError === "string") {
        if (messageOrError) {
          message = messageOrError;
        }
      } else if (
        messageOrError.response &&
        messageOrError.response.data.error
      ) {
        message = messageOrError.response.data.error.description;
      }
      return message;
    },
    handlePaymentError(messageOrError) {
      let message = this.getErrorMessage(messageOrError);
      let error = "Your payment couldn't be processed. " + message;
      this.error = error;
      this.retrying = false;
    },
    done () {
      this.$store.commit("setUserHasSubscription");
      this.$emit('done');
    }
  },
};
</script>
